// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f5c4bf85","553":"bc6133cc","977":"acc9c6d9"}[chunkId] + ".chunk.js";
};